import { __read, __spreadArray } from "tslib";
import { IdentifyOperation } from '@amplitude/analytics-types';
import { BASE_CAMPAIGN } from './constants';
export var isCampaignEvent = function (event) {
    if (event.user_properties) {
        var properties = event.user_properties;
        var $set = properties[IdentifyOperation.SET] || {};
        var $unset = properties[IdentifyOperation.UNSET] || {};
        var userProperties_1 = __spreadArray(__spreadArray([], __read(Object.keys($set)), false), __read(Object.keys($unset)), false);
        return Object.keys(BASE_CAMPAIGN).every(function (value) { return userProperties_1.includes(value); });
    }
    return false;
};
//# sourceMappingURL=campaign-helper.js.map